import React from 'react';
import { Category, Product, ProductPayload } from "../types";


export const prepareRequestData = (data: Product): ProductPayload => {
    let formattedProperties: Record<string, string> = {};

    if (Array.isArray(data.properties)) {
        // Если properties — массив, преобразуем его в объект
        formattedProperties = data.properties.reduce((acc, prop) => {
            acc[prop.key] = prop.value;
            return acc;
        }, {} as Record<string, string>);
    } else if (data.properties && typeof data.properties === 'object') {
        // Если properties уже объект, просто используем его
        formattedProperties = data.properties as Record<string, string>;
    } else {
        // Если properties отсутствует или равен null, используем пустой объект
        formattedProperties = {};
    }

    return {
        ...data,
        category_id: Number(data.category_id),
        brand_id: Number(data.brand_id),
        skin_types_ids: Array.isArray(data.skin_types_ids) ? data.skin_types_ids.map(Number) : [],
        ingredients_ids: Array.isArray(data.ingredients_ids) ? data.ingredients_ids.map(Number) : [],
        problems_ids: Array.isArray(data.problems_ids) ? data.problems_ids.map(Number) : [],
        properties: formattedProperties,
    };
};

export const renderCategories = (categories: Category[]): JSX.Element[] => {
    const renderOptions = (category: Category, prefix = ''): JSX.Element[] => [
        <option key={category.id} value={category.id} >
            {prefix + category.name}
        </option>,
        ...(category.children?.flatMap((child) => renderOptions(child, `${prefix}-- `)) || []),
    ];

    return categories.flatMap((category) => renderOptions(category));
};

export const filterOptions = (options: any[], search: string) =>
    options.filter((option) => option.name.toLowerCase().includes(search.toLowerCase()));
